<app-breadcrumb [title]="'Responsabilidades en SV'" [items]="['Responsabilidad y Comportamiento Seguro']"
    [active_item]="'Responsabilidades en SV'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center">
            <i class="icofont icofont-shield-alt me-2"></i>
            <h5 class="mb-0"><strong>RESPONSABILIDADES EN SEGURIDAD VIAL</strong></h5>
        </div>

        <div class="card-body">
            <ul ngbNav #responsabilidadTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

                <!-- ===================== TAB 1: FORMULARIO ===================== -->
                <li [ngbNavItem]="1">
                    <a ngbNavLink>
                        <strong><i class="icofont icofont-plus me-1"></i> FORMULARIO RESPONSABILIDAD</strong>
                    </a>

                    <ng-template ngbNavContent>
                        <form [formGroup]="responsabilidadForm" (ngSubmit)="guardar()" class="pt-3" novalidate>

                            <div class="card border-0 shadow-sm mb-3">
                                <div class="card-body">
                                    <div class="row g-3">

                                        <!-- Responsabilidad -->
                                        <div class="col-md-6">
                                            <label class="form-label fw-semibold">
                                                Responsabilidad: <span class="text-danger">*</span>
                                            </label>
                                            <textarea class="form-control text-uppercase"
                                                formControlName="responsabilidad"
                                                placeholder="Ej. Reportar oportunamente los siniestros viales"
                                                [class.is-invalid]="responsabilidadForm.get('responsabilidad')?.invalid && responsabilidadForm.get('responsabilidad')?.touched">
                                            </textarea>
                                            <div class="invalid-feedback"
                                                *ngIf="responsabilidadForm.get('responsabilidad')?.invalid && responsabilidadForm.get('responsabilidad')?.touched">
                                                La responsabilidad es obligatoria.
                                            </div>
                                        </div>

                                        <!-- Descripción -->
                                        <div class="col-md-6">
                                            <label class="form-label fw-semibold">
                                                Descripción (opcional):
                                            </label>
                                            <textarea class="form-control" formControlName="descripcion"
                                                placeholder="Detalle adicional de la responsabilidad...">
                                            </textarea>
                                        </div>

                                        <!-- Cargos a los que aplica -->
                                        <div class="col-md-6">
                                            <label class="form-label fw-semibold">
                                                Aplica a los cargos: <span class="text-danger">*</span>
                                            </label>
                                            <ng-select [items]="cargos" bindLabel="cargos" bindValue="id"
                                                [multiple]="true" [loading]="cargandoCargos"
                                                placeholder="Seleccione uno o varios cargos..."
                                                formControlName="cargos"
                                                [ngClass]="{ 'is-invalid': responsabilidadForm.get('cargos')?.touched && responsabilidadForm.get('cargos')?.invalid }">
                                            </ng-select>
                                            <div class="invalid-feedback"
                                                *ngIf="responsabilidadForm.get('cargos')?.invalid && responsabilidadForm.get('cargos')?.touched">
                                                Debes seleccionar al menos un cargo.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center gap-2 mt-4">
                                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                                    <span *ngIf="!guardando">
                                        <i class="icofont icofont-save me-1"></i>
                                        {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                                    </span>
                                    <span *ngIf="guardando">
                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                        {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
                                    </span>
                                </button>

                                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion"
                                    (click)="cancelarEdicion()" [disabled]="guardando">
                                    <i class="icofont icofont-close me-1"></i>Cancelar edición
                                </button>
                            </div>

                        </form>
                    </ng-template>
                </li>

                <!-- ===================== TAB 2: LISTADO ===================== -->
                <li [ngbNavItem]="2">
                    <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO
                            RESPONSABILIDADES</strong></a>
                    <ng-template ngbNavContent>
                        <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
                            <div class="card-body pt-3">

                                <div *ngIf="cargandoListado" class="text-center py-4">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <p class="mt-2 mb-0">Cargando responsabilidades...</p>
                                </div>

                                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                                    <div class="col-md-3">
                                        <select class="form-select" [(ngModel)]="filtroEstado"
                                            (change)="aplicarFiltro()">
                                            <option [ngValue]="null">Todos</option>
                                            <option [ngValue]="1">Activos</option>
                                            <option [ngValue]="0">Inactivos</option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 ms-auto">
                                        <div class="input-group">
                                            <input type="text" class="form-control"
                                                placeholder="Buscar por responsabilidad..." [(ngModel)]="filtro"
                                                (input)="aplicarFiltro()" />
                                            <span class="input-group-text">
                                                <i class="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                                    <ng-container *ngIf="responsabilidadesPorCargo?.length > 0; else sinDatos">
                                        <table id="tblResponsabilidadesSv"
                                            class="table table-bordered table-hover align-middle">
                                            <thead class="bg-primary text-white">
                                                <tr>
                                                    <th class="text-center" style="width: 25%;">CARGO</th>
                                                    <th class="text-center">RESPONSABILIDADES ASIGNADAS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let grupo of responsabilidadesPorCargo | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                                    <td class="text-center fw-semibold">{{ grupo.cargo }}</td>
                                                    <td>
                                                        <ul class="mb-0 ps-3">
                                                            <li *ngFor="let r of grupo.responsabilidades" class="d-flex justify-content-between align-items-center mb-2">
                                                                <span>{{ r.responsabilidad }}</span>
                                                                <div class="d-flex gap-1 ms-2">
                                                                    <button
                                                                        class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                                        *ngIf="Number(r.estado) === 1" ngbTooltip="Editar"
                                                                        (click)="editarResponsabilidadDesdeTabla(r, grupo)">
                                                                        <i class="icofont icofont-pencil" style="font-size: .75rem;"></i>
                                                                    </button>
                                                                    <button
                                                                        class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                                        *ngIf="Number(r.estado) === 1"
                                                                        ngbTooltip="Inactivar"
                                                                        (click)="cambiarEstadoResponsabilidad(r.id, 0)">
                                                                        <i class="icofont icofont-close" style="font-size: .75rem;"></i>
                                                                    </button>
                                                                    <button
                                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                                        *ngIf="Number(r.estado) !== 1"
                                                                        ngbTooltip="Activar"
                                                                        (click)="cambiarEstadoResponsabilidad(r.id, 1)">
                                                                        <i class="icofont icofont-check" style="font-size: .75rem;"></i>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>

                                    <ng-template #sinDatos>
                                        <div class="text-center py-4 text-primary">No hay responsabilidades
                                            registradas.</div>
                                    </ng-template>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-4">
                                            <div class="d-flex align-items-center">
                                                <label for="pageSizeResponsabilidades" class="me-2">Mostrar:</label>
                                                <select id="pageSizeResponsabilidades" class="form-select w-auto"
                                                    [(ngModel)]="pageSize" (change)="page = 1">
                                                    <option *ngFor="let size of [5, 10, 20, 50, 100]"
                                                        [value]="size">{{ size }}</option>
                                                </select>
                                                <span class="ms-2">registros por página</span>
                                            </div>

                                            <div class="text-center flex-grow-1">
                                                Total Cargos:
                                                <a class="badge badge-primary"><b>{{
                                                        responsabilidadesPorCargo?.length || 0 }}</b></a>
                                            </div>

                                            <div class="text-end paginador-personalizado">
                                                <pagination-controls (pageChange)="page = $event" [maxSize]="5"
                                                    [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                                    nextLabel="Siguiente"></pagination-controls>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                            <div class="btn-showcase text-center">
                                                <button class="btn btn-outline-success-2x" type="button"
                                                    ngbTooltip="Exportar a Excel"
                                                    (click)="exportarExcel('tblResponsabilidadesSv','listado_responsabilidades_sv')">
                                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                                </button>
                                                <button class="btn btn-outline-danger-2x" type="button"
                                                    ngbTooltip="Exportar a PDF"
                                                    (click)="exportToPDF('tblResponsabilidadesSv','listado_responsabilidades_sv','Listado de responsabilidades en SV')">
                                                    <i class="icofont icofont-file-pdf"></i> PDF
                                                </button>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </ng-template>
                </li>

            </ul>

            <div [ngbNavOutlet]="responsabilidadTab" class="mt-2"></div>
        </div>
    </div>
</div>